<template>
  <div class="conten-desc">
    <div class="df vertical">
      <div class="step-label">{{ props.title }}</div>
    </div>

    <template
      v-for="(submission, submissionIndex) in submissionList"
      :key="submissionIndex"
    >
      <div class="inspection-area">
        <div class="df vertical" style="margin-bottom: 10px">
          <a-input
            :disabled="props.disabled"
            placeholder="请输入送检人"
            v-model:value="submission.inspectionPersonnel"
          ></a-input>
          <div style="width: 80px; margin-left: 10px">送检人</div>
        </div>

        <div class="df vertical">
          <a-input
            :disabled="props.disabled"
            placeholder="请输入质检人"
            v-model:value="submission.qualityPersonnel"
          ></a-input>
          <div style="width: 80px; margin-left: 10px">质检人</div>
        </div>

        <template v-for="(item, index) in submission.list" :key="index">
          <div class="df vertical describe">
            <div>
              <div class="df vertical">
                <div class="subtitle">问题类型</div>
                <a-select
                  v-model:value="item.type"
                  :disabled="props.disabled"
                  style="width: 200px"
                  :options="
                    props.type === 'oqc'
                      ? oqcProblemOption
                      : processProblemOption
                  "
                  allowClear
                >
                </a-select>
              </div>
              <div class="df vertical">
                <div class="subtitle">问题描述</div>
                <a-textarea
                  v-model:value="item.desc"
                  :disabled="props.disabled"
                  auto-size
                  allowClear
                  style="width: 200px"
                ></a-textarea>
              </div>

              <div class="df vertical">
                <div class="subtitle">图片</div>
                <upload-img-vue
                  ref="imgRefList"
                  :attachment="item.picture"
                  :disabled="props.disabled"
                  :requestFn="uploadInspectionAttachment"
                ></upload-img-vue>
              </div>

              <div class="df vertical">
                <div class="subtitle">视频</div>
                <upload-video-vue
                  ref="videoRefList"
                  :attachment="item.video"
                  :disabled="props.disabled"
                  :requestFn="uploadInspectionAttachment"
                ></upload-video-vue>
              </div>

              <!-- <div class="df vertical">
                <div class="subtitle">原因</div>
                <a-textarea
                  v-model:value="item.reason"
                  :disabled="!props.ROSAuthority"
                  auto-size
                  allowClear
                  style="width: 180px"
                ></a-textarea>
              </div>

              <div class="df vertical">
                <div class="subtitle">解决方案</div>
                <a-textarea
                  v-model:value="item.solution"
                  :disabled="!props.ROSAuthority"
                  auto-size
                  allowClear
                  style="width: 180px"
                ></a-textarea>
              </div> -->
            </div>

            <div>
              <MinusCircleOutlined
                v-if="!props.disabled"
                class="dynamic-delete-button"
                :disabled="question.length === 1"
                @click="removeQuestion(submission.list, index)"
              />
            </div>
          </div>
        </template>
      </div>

      <div class="df both-side" style="margin-top: 10px; margin-bottom: 10px">
        <a-button
          type="dashed"
          style="width: 110px"
          @click="addAnalyse(submission.list, submissionIndex)"
          class="space"
          :disabled="props.disabled || props.questionDisabled"
        >
          <PlusOutlined />
          增加问题
        </a-button>

        <a-button
          type="danger"
          style="width: 140px"
          @click="deleteSubmission(submissionIndex)"
          class="space"
          :disabled="props.disabled"
        >
          <MinusOutlined />
          删除{{ submissionIndex + 1 }}次质检
        </a-button>
      </div>
    </template>
    <a-button
      type="primary"
      :class="[submissionList.length > 0 ? 'button-space' : '']"
      @click="addsubmission"
      class="space"
      :disabled="props.disabled"
    >
      <!-- <PlusOutlined /> -->
      <!-- 增加检查人员 -->
      新增{{ submissionList.length + 1 }}次质检
    </a-button>
  </div>
</template>

<script>
import { computed, defineComponent, nextTick, reactive, ref, watch } from "vue";
import {
  PlusOutlined,
  MinusCircleOutlined,
  MinusOutlined,
} from "@ant-design/icons-vue";
import {
  Toast,
  uploadMedia,
  showUploading,
  hideUploading,
} from "@/utils/index";
import { uploadInspectionAttachment } from "@/request/view/qualityInspection";
import { saveOrUpdateContentDesc } from "@/request/view/repair";
import { processProblemOption } from "@/views/productDaily/components/quality/PQC/view/serve/option";
import { oqcProblemOption } from "@/views/productDaily/warehouse/option";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import { useStore } from "vuex";

export default defineComponent({
  components: {
    PlusOutlined,
    uploadImgVue,
    uploadVideoVue,
    MinusOutlined,
    MinusCircleOutlined,
  },
  props: {
    questionDesc: String,
    disabled: Boolean,
    questionDisabled: Boolean,
    ROSAuthority: Boolean,
    type: String,
  },
  setup(props, context) {
    const store = useStore();

    const isMobile = computed(() => store.state.isMonile);

    const submissionList = reactive([]);

    const question = reactive([]);

    const imgRefList = ref();

    const videoRefList = ref();

    const uploadFile = () => {
      return new Promise((resolve, reject) => {
        if (submissionList.length === 0) {
          reject("");
          Toast("warning", "请新增质检填写送检人和质检人", 3);
          return;
        }

        submissionList.forEach((item) => {
          if (!item.inspectionPersonnel || !item.qualityPersonnel) {
            Toast("warning", "请填写送检人和质检人", 3);
            reject("");
            return;
          }
        });

        const promiseArr = [];
        submissionList.forEach((item) => {
          let promiseIndex = 0;
          promiseArr.forEach((item) => {
            promiseIndex += item.length;
          });

          const pArr = [];
          for (let i = 0; i < item.list.length; i += 1) {
            const imgRef = imgRefList.value[i + promiseIndex];
            const videoRef = videoRefList.value[i + promiseIndex];
            let p = uploadMedia(imgRef, videoRef);
            pArr.push(p);
          }
          promiseArr.push(pArr);
        });
        const allPro = [];
        promiseArr.forEach((promiseList) => {
          allPro.push(Promise.all(promiseList));
        });
        Promise.all(allPro)
          .then((res) => {
            console.log(res);
            res.forEach((media, index) => {
              media.forEach((mediaList, subIndex) => {
                const [imgFileUrl, videoFileUrl] = mediaList;
                submissionList[index].list[subIndex].picture =
                  JSON.stringify(imgFileUrl);
                submissionList[index].list[subIndex].video =
                  JSON.stringify(videoFileUrl);
              });
            });
            resolve(submissionList);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const addAnalyse = (item, index) => {
      item.push({
        picture: null,
        type: null,
        desc: null,
        video: null,
        solution: null,
        reason: null,
      });
      console.log(submissionList, index);
    };

    const removeQuestion = (item, index) => {
      item.splice(index, 1);
    };

    const updateInspectionCount = () => {
      context.emit("updateInspectionCount", submissionList.length);
    };

    const addsubmission = () => {
      submissionList.push({
        inspectionPersonnel: null,
        qualityPersonnel: null,
        list: [],
      });
      updateInspectionCount();
    };

    const deleteSubmission = (index) => {
      submissionList.splice(index, 1);
      updateInspectionCount();
    };

    watch(
      () => props.questionDesc,
      (val) => {
        submissionList.length = 0;
        if (val) {
          submissionList.push(...JSON.parse(val));
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      store,
      uploadFile,
      addAnalyse,
      imgRefList,
      videoRefList,
      question,
      removeQuestion,
      isMobile,
      submissionList,
      oqcProblemOption,
      processProblemOption,
      addsubmission,
      deleteSubmission,
      uploadInspectionAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
.conten-desc {
  color: #000;
  .subtitle {
    font-size: 16px;
    width: 70px;
    text-align: right;
    margin: 10px 16px 10px 0;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .describe {
    background: #f9f9f9;
    box-shadow: 0 0 6px 0 #f1f1f1;
    border-radius: 6px;
    padding: 4px;
    margin-top: 10px;
  }

  .dynamic-delete-button {
    margin-left: 20px;
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #000;
    transition: all 0.3s;
  }

  .dynamic-delete-button:hover {
    color: #000;
  }

  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.inspection-area {
  padding: 10px;
  background: #dddddd;
  box-shadow: 0 0 6px 0 #f1f1f1;
  border-radius: 10px;
}
</style>
